"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrontendRoute = exports.Page = exports.localisedRoutes = void 0;
var frontendRoutes_1 = require("./frontendRoutes");
Object.defineProperty(exports, "localisedRoutes", { enumerable: true, get: function () { return frontendRoutes_1.localisedRoutes; } });
Object.defineProperty(exports, "Page", { enumerable: true, get: function () { return frontendRoutes_1.Page; } });
function getFrontendRoute(page, locale, fallbackLocale) {
    if (locale === void 0) { locale = 'en'; }
    if (fallbackLocale === void 0) { fallbackLocale = 'en'; }
    var pageRoutes = frontendRoutes_1.localisedRoutes[page];
    if (!pageRoutes)
        throw Error("Page " + page + " not found in routes!");
    var route = pageRoutes[locale];
    if (route)
        return route;
    var fallbackRoute = pageRoutes[fallbackLocale];
    if (fallbackRoute) {
        console.warn("Page \"" + page + "\" not found for locale \"" + locale + "\", serving fallback locale.");
        return fallbackRoute;
    }
    var guaranteedRoute = pageRoutes.en;
    console.warn("Page \"" + page + "\" not found either for \"" + locale + "\" or fallback locale \"" + fallbackLocale + "\". Serving english version.");
    return guaranteedRoute;
}
exports.getFrontendRoute = getFrontendRoute;
